<template>
  <div class="flex mb-12 lab-form">
    <div class="w-3/5 content-left-panel">
      <vs-tabs class="mt-10" alignment="fixed">
        <vs-tab class="pt-8" label="Basic information">
          <lab-form-content
            ref="labFormContent"
            :embedded="false"
            :onClick="saveLab"
          />
        </vs-tab>
        <vs-tab class="pt-8" label="Objectives">
          <lab-objectives-content ref="objectivesContent" />
        </vs-tab>
        <vs-tab class="pt-8" label="Flags">
          <lab-flags-content
            ref="flagsContent"
            :flags="getCurrentLab.flags"
            :labType="getCurrentLab.lab_type"
            :saveToApi="saveLab"
          />
        </vs-tab>
      </vs-tabs>
    </div>
    <div class="w-2/5 pl-10 content-right-panel">
      <div class="flex flex-wrap mb-10" v-if="isEditing">
        <div class="w-full content-status">
          <label class="vs-input--label">Status</label>
          <v-select
            v-model="labStatus"
            :clearable="false"
            placeholder="Select one"
            :options="getLabAllStatus"
            :reduce="(status) => status.value"
          />
        </div>
      </div>
      <div class="flex mb-10 -mx-2" v-if="isEditing">
        <div class="w-1/2 mx-2 modified-date">
          <label class="vs-input--label">Modified on</label>
          <vs-input
            disabled
            :value="getCurrentLab.modified | dateFormat"
          ></vs-input>
        </div>
        <div class="w-1/2 mx-2 created-date">
          <label class="vs-input--label">Created on</label>
          <vs-input
            disabled
            :value="getCurrentLab.created | dateFormat"
          ></vs-input>
        </div>
      </div>
      <div class="flex -mx-2 action-buttons">
        <vs-button
          class="w-full mx-2"
          color="primary"
          icon-pack="feather"
          @click="saveLab"
          >Save</vs-button
        >
      </div>
      <div v-if="!localLoading" class="mt-10">
        <h4>Related content</h4>
        <RelatedContentList :metadata="getCurrentLab.metadata" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import vSelect from 'vue-select'
import labFormContent from './forms/LabFormContent'
import labObjectivesContent from './forms/LabObjectivesContent'
import labFlagsContent from './forms/LabFlagsContent'
import RelatedContentList from './components/RelatedContentList.vue'

export default {
  components: {
    labFormContent,
    labObjectivesContent,
    labFlagsContent,
    'v-select': vSelect,
    RelatedContentList,
  },
  data() {
    return {
      localLoading: false,
    }
  },
  async created() {
    if (this.$route && this.$route.params.id) {
      if (this.$route.params.id !== this.getCurrentLab.id) {
        this.getLabToEdit(this.$route.params.id)
      }
    } else {
      this.resetCurrentLab()
    }
  },
  computed: {
    ...mapGetters('app', ['getSelectedCompany']),
    ...mapGetters('labs', ['getCurrentLab', 'getLabAllStatus']),
    ...mapGetters('taxonomy', ['getLabTaxonomy']),
    isEditing() {
      return this.$route.name === 'edit-lab'
    },
    labStatus: {
      get() {
        return this.getCurrentLab.status
      },
      set(status) {
        this.saveLabStatus({ status })
      },
    },
  },
  methods: {
    ...mapActions('labs', [
      'getLabAction',
      'fetchObjectives',
      'resetCurrentLab',
      'saveLabToApi',
      'assignTaxonomiesToLab',
    ]),
    ...mapMutations('labs', {
      saveLabStatus: 'STORE_CURRENT_LAB',
    }),
    async saveTaxonomies() {
      try {  
        const addedSkills = (this.getLabTaxonomy && this.getLabTaxonomy.contentId === this.getCurrentLab.id)
          ? this.getLabTaxonomy.addedSkills
          : []
        await this.assignTaxonomiesToLab({
          contentId: this.getCurrentLab.id,
          addedSkills,
        })
      } catch (error) {
        this.showError(error)
      }
    },
    async saveLab() {
      try {
        this.$vs.loading()

        if (this.$route.name !== 'create-lab') {
          await this.saveTaxonomies()
        }

        const response = await this.saveLabToApi()

        if (this.$route.name === 'create-lab') {
          this.$router.push({ name: 'edit-lab', params: { id: response.id } })
        }

        this.$vs.notify({
          title: 'Success',
          text: 'Lab saved',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
        })
      } catch (error) {
        this.showError(error)
      }
      this.$vs.loading.close()
    },
    async getLabToEdit(labId) {
      this.$vs.loading()
      this.localLoading = true
      try {
        await this.getLabAction({ labId })
        await this.fetchObjectives(labId)
        if (this.getCurrentLab.company !== this.getSelectedCompany) {
          this.$router.push({ name: 'create-lab' })
          this.$vs.notify({
            title: 'Warning',
            text: 'Lab you were editing belongs to a different company',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
          })
        }
      } catch (error) {
        this.showError(error)
      } finally {
        this.$vs.loading.close()
        this.localLoading = false
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'create-lab') {
      this.resetCurrentLab()
    }
    if (to.name === 'edit-lab') {
      this.getLabToEdit(to.params.id)
    }
    next()
  },
}
</script>
<style lang="scss" scoped></style>
